import React from 'react';
import { default as GridProviderComp } from './grid-provider';
import { Grid } from './interfaces';
import useStore from './use-store';

const GridProvider: Grid.IComp<Grid.Props> = (props) => <GridProviderComp {...props} />;
GridProvider.useStore = useStore;

export type { Grid };
export default GridProvider;